import { render } from "./CalculationItemDimensionsSquare.vue?vue&type=template&id=996247c0&scoped=true"
import script from "./CalculationItemDimensionsSquare.vue?vue&type=script&lang=js"
export * from "./CalculationItemDimensionsSquare.vue?vue&type=script&lang=js"

import "./CalculationItemDimensionsSquare.vue?vue&type=style&index=0&id=996247c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996247c0"]])

export default __exports__